import { ContentfulPageProductPageV2 } from "../types/ContentfulTypes";
import { Logger } from "../logging/logger";
import { getMediaImage } from "./ProductBuilderHelper";

export default class Validation {
  public static validate(data: ContentfulPageProductPageV2) {
    this.validateCloudinaryUrlsArePresent(data);
  }

  private static validateCloudinaryUrlsArePresent(data: ContentfulPageProductPageV2) {
    // Log an error if both hero images and overview tab images are missing url's
    // This is to catch an occurance of a particular issue where all/most images not having url's on the page

    let urlsAreMissing = false;
    data.heroGallery.forEach(media => (urlsAreMissing = urlsAreMissing || !getMediaImage(media)));

    if (urlsAreMissing) {
      const overviewTab = data.globalTabs?.find(tab => tab.__typename === "tabOverview");
      if (overviewTab) {
        if (
          overviewTab.multimedia?.cloudinaryImage &&
          !overviewTab.multimedia.cloudinaryImage.cloudinaryUrl
        ) {
          // Log this error if both hero images are missing urls, as well as the overview tab
          Logger.instance.error("Many images do not have Cloudinary urls");
        }
      }
    }
  }
}
